module.exports = __webpack_public_path__ + "static/media/logo.4912085f.jpg";